import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";




export const createTask = (body) => {
    return axiosInstance
      .post(`/createNewTask`, body)
      .then((response) => {
        return response.data.response[0];
      })
      .catch((error) => {
        var response = catchAxiosError(error);
         return response;
      });
  };

  export const getAllTasks = (body) => {
    return axiosInstance
      .get(`/getAllTasks`,body)
      .then((response) => {
        
        return response.data.response;
      })
      .catch((error) => {
        catchAxiosError(error);
      });
  };

  export const deleteTask = (id) => {

    return axiosInstance
      .delete(`/deleteTask/${id}`)
      .then((response) => {
        
        return response.data.response[0];
      })
      .catch((error) => {
        catchAxiosError(error);
      });
  };

  export const UpdateTask = (body) => {
    return axiosInstance
      .put(`/updateTask/${body.id}`, body, {
        headers: {
          'Content-Type': 'application/json', // Set the content type to JSON
        },
      })
      .then((response) => {
        return response.data.response[0];
      })
      .catch((error) => {
        var response = catchAxiosError(error);
        return response;
      });
  };
  




  
//private methods

const catchAxiosError = (error) => {
    if (!error.response) {
      // network error
      return json(
        {},
        {
          status: 404,
        }
      );
    } else {
      const code = error.response.status;
      const message = error.message;
      return { errors:[message]}
    }
  };